<script>
  import Pagination from '@/components/pagination/index.vue';
  import GroupSelect from '@/components/GroupSelect/index.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import optionData from '@/assets/js/optionData';
  import {
    api,
    detailBillingDelete,
    detailBillingDownload,
    detailBillingDownloadTemplate,
    detailBillingInfo,
    detailBillingList,
  } from 'api/billing/detail';
  import { totalInfoPropertyMap } from '@/views/billing/common';
  import { handleSortItem } from 'utils/utils';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { roleUserMixins } from '@/mixins/roleUserMixins';
  import checkboxWatcher from '@/mixins/checkboxWatcher';
  import { isNotBlank, numToPercentStr, splitStrByLineBreak } from 'utils/string';
  import BillingDetailBaseForm from '@/views/billing/forms/BillingDetailBaseForm.vue';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';
  import { IntegrationType } from '@/assets/js/constants';
  import { formatDate } from 'utils/dateutils';

  export default {
    mixins: [myMixin, billingEnumMixins, roleUserMixins, checkboxWatcher, financeInfoMixins],
    components: {
      BillingDetailBaseForm,
      BaseListLayout,
      Pagination,
      GroupSelect,
    },
    data() {
      return {
        exportDataLoading: false,
        downloadTemplateLoading: false,
        baseFormType: 'new',
        baseFormVisible: false,
        uploadVisible: false,
        uploadSuccessMessage: null,
        uploadErrorMessage: null,
        groupItemCheck: {
          affiliateChecked: false,
          affiliateNameChecked: false,
          advertiserIdChecked: false,
          advertiserNameChecked: false,
          offerIdChecked: false,
          offerNameChecked: false,
          affIntegrationTypeChecked: false,
          advIntegrationTypeChecked: false,
          affPaymentStatusChecked: false,
          advReceiptStatusChecked: false,
          advertiserOfferIdChecked: false,
          advertiserOfferNameChecked: false,
          networkPartnerIdChecked: false,
          agencyPartnerIdChecked: false,
          partnerAdvertiserAccountChecked: false,
          pkgNameChecked: false,
          countryChecked: false,
          advInvoiceAppStatusChecked: false,
          affBillingAppStatusChecked: false,
          advReconciliationProgressChecked: false,
          affReconciliationProgressChecked: false,
          amChecked: false,
          pmChecked: false,
          bdChecked: false,
          advCompanyPlatformChecked: false,
          affCompanyPlatformChecked: false,
        },
        total: 0,
        listLoading: false,
        integrationType: IntegrationType,
        advertiserOfferIdList: '',
        advertiserOfferNameList: '',
        offerIdList: '',
        offerNameList: '',
        pkgNameList: '',
        advertiserIdList: [],
        affiliateNameList: [],
        timezoneOption: optionData.timezoneOption,
        dataList: [],
        addDetail: {
          recordDate: '',
          timezone: '+00:00',
        },
        totalInfo: {},
        filter: {
          page: 1,
          pageSize: 10,
          recordDateRange: [formatDate(new Date(), 'yyyy-MM'), formatDate(new Date(), 'yyyy-MM')],
          networkPartnerId: undefined,
          agencyPartnerId: undefined,
          partnerAdvertiserAccount: undefined,
          offerIdList: undefined,
          offerNameList: undefined,
          pkgNameList: undefined,
          timezone: '+00:00',
          affiliateIntegrationType: undefined,
          affiliateIdList: undefined,
          affiliateNameList: undefined,
          advertiserIntegrationType: undefined,
          affPaymentStatus: undefined,
          advReceiptStatus: undefined,
          advertiserOfferIdList: undefined,
          advertiserOfferNameList: undefined,
          advReconciliationProgress: undefined,
          affReconciliationProgress: undefined,
          amList: [],
          pmList: [],
          advBdList: [],
          affBdList: [],
          advertiserNameList: undefined,
          advertiserIdList: undefined,
          groupItems: [],
          sortItems: [],
          advPaymentStatus: undefined,
          advInvoiceAppStatus: undefined,
          affBillingAppStatus: undefined,
          advCompanyPlatform: undefined,
          affCompanyPlatform: undefined,
        },
      };
    },
    computed: {
      api() {
        return api;
      },
    },
    created() {
      this.filter.groupItems.push('record_date');
    },
    mounted() {
      this.getAffiliateList();
      this.getSourceIdsList();
      this.checkboxConfig.targetArray = this.filter.groupItems;
      this.checkboxConfig.searchFunc = this.handleSearch;
    },
    methods: {
      isNotBlank,
      splitStrByLineBreak,
      numToPercentStr,
      customSummaryMethod(param) {
        const { columns } = param;
        const sums = [];
        if (this.totalInfo === undefined) {
          return sums;
        }

        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const totalProperty = totalInfoPropertyMap[column.property];
          const value =
            isNotBlank(totalProperty) && totalProperty.includes('Rate')
              ? numToPercentStr(this.totalInfo[totalProperty])
              : this.totalInfo[totalProperty];
          sums[index] = totalProperty ? value : '';
        });

        return sums;
      },
      getBillingAppStatusLabel(status) {
        if (status === null || status === undefined) {
          return '';
        }
        return this.affBillingAppStatusList.find((item) => item.value === status)?.label || '';
      },
      getAffiliateName(ids) {
        if (ids === undefined || ids === null) {
          return undefined;
        }
        let names = [];
        for (let index = 0; index < ids.length; index++) {
          let id = ids[index];
          for (let i = 0; i < this.affiliatesGroupList.length; i++) {
            for (let j = 0; j < this.affiliatesGroupList[i].children.length; j++) {
              if (this.affiliatesGroupList[i].children[j].id === id) {
                names.push(this.affiliatesGroupList[i].children[j].label.replace(id + ' - ', ''));
              }
            }
          }
        }
        return names;
      },
      handleUploadSuccess(response) {
        if (response.success && response.code === 200) {
          this.$message.success('File uploaded successfully!');
          this.uploadSuccessMessage = 'File uploaded successfully!';
          this.handleSearch(1);
        } else {
          this.handleUploadError(response);
        }
      },
      handleUploadError(err) {
        this.uploadErrorMessage = err.message;
        this.$message.error('Error uploading file: ' + err.message);
      },
      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          this.filter.sortItems = [];
          this.handleSearch(1);
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleSearch() {
        if (isNotBlank(this.offerIdList)) {
          this.filter.offerIdList = this.offerIdList.split(';');
          this.filter.offerIdList = this.filter.offerIdList.filter((item) => item !== '');
        }
        if (isNotBlank(this.offerNameList)) {
          this.filter.offerNameList = this.offerNameList.split(';');
          this.filter.offerNameList = this.filter.offerNameList.filter((item) => item !== '');
        }
        if (isNotBlank(this.pkgNameList)) {
          this.filter.pkgNameList = this.pkgNameList.split(';');
          this.filter.pkgNameList = this.filter.pkgNameList.filter((item) => item !== '');
        }
        if (isNotBlank(this.advertiserOfferNameList)) {
          this.filter.advertiserOfferNameList = this.advertiserOfferNameList.split(';');
          this.filter.advertiserOfferNameList = this.filter.advertiserOfferNameList.filter(
            (item) => item !== ''
          );
        }
        if (isNotBlank(this.advertiserOfferIdList)) {
          this.filter.advertiserOfferIdList = this.advertiserOfferIdList.split(';');
          this.filter.advertiserOfferIdList = this.filter.advertiserOfferIdList.filter(
            (item) => item !== ''
          );
        }
        this.filter.affiliateNameList = this.getAffiliateName(this.affiliateNameList);
        this.listLoading = true;
        detailBillingList(this.filter)
          .then((response) => {
            const result = response.result;
            if (result.dataList === undefined) {
              this.dataList = [];
            } else {
              this.dataList = result.dataList;
            }
            this.total = response.total;
            this.totalInfo = result.totalInfo;
          })
          .finally(() => {
            this.listLoading = false;
          });
      },
      downloadTemplateClick() {
        this.downloadTemplateLoading = true;
        detailBillingDownloadTemplate().finally(() => {
          setTimeout(() => {
            this.downloadTemplateLoading = false;
          }, 300);
        });
      },
      handleSelectAll() {
        Object.keys(this.groupItemCheck).forEach((key) => {
          this.$set(this.groupItemCheck, key, true);
        });
        this.handleSelectAllCb();
      },
      handleUnSelectAll() {
        Object.keys(this.groupItemCheck).forEach((key) => {
          this.$set(this.groupItemCheck, key, false);
        });
        this.handleUnSelectAllCb();
      },
      handleSelectArgument() {
        this.handleUnSelectAll();
        this.groupItemCheck.offerIdChecked = true;
        this.groupItemCheck.advertiserIdChecked = true;
        this.groupItemCheck.affiliateChecked = true;
        this.groupItemCheck.pkgNameChecked = true;
        this.groupItemCheck.countryChecked = true;
        this.handleSelectSpecialCb(
          'offer_id',
          'advertiser_id',
          'affiliate_id',
          'pkg_name',
          'country'
        );
      },
      openAddDialogClick() {
        this.addDetail = { timezone: '+00:00' };
        this.baseFormType = 'new';
        this.baseFormVisible = true;
      },
      checkUpdateAndDelete() {
        return (
          this.groupItemCheck.offerIdChecked &&
          this.groupItemCheck.advertiserIdChecked &&
          this.groupItemCheck.affiliateChecked &&
          this.groupItemCheck.pkgNameChecked &&
          this.groupItemCheck.countryChecked
        );
      },
      handleUpdate(row) {
        if (!this.checkUpdateAndDelete()) {
          this.$message.error('先点击开启更新删除');
          return;
        }
        detailBillingInfo(row.id).then(() => {
          this.baseFormVisible = true;
          this.baseFormType = 'update';
          this.addDetail = Object.assign({}, row);
        });
      },
      handleDelete(id) {
        if (!this.checkUpdateAndDelete()) {
          this.$message.error('先点击开启更新删除');
          return;
        }
        this.$confirm('此操作将删除记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            detailBillingDelete(id).then((response) => {
              if (response.code === 200 && response.success) {
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                });
              } else {
                this.$message({
                  type: 'info',
                  message: '删除失败!',
                });
              }
            });
          })
          .catch(() => {});
      },
      openUploadDialogClick() {
        this.uploadVisible = true;
        this.uploadSuccessMessage = null;
        this.uploadErrorMessage = null;
      },
      exportExcelFileClick() {
        this.exportDataLoading = true;
        detailBillingDownload(this.filter).finally(() => {
          setTimeout(() => {
            this.exportDataLoading = false;
          }, 300);
        });
      },
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleCurrentChange(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },
      offerDetailClick(row) {
        const { href } = this.$router.resolve({
          path: '/offer/detail',
          query: {
            offerId: row.offerId,
          },
        });
        window.open(href, '_blank');
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Detail Billing'">
    <template #search>
      <el-form :model="filter" :inline="true" label-width="230px" ref="searchForm">
        <!-- 基础信息筛选 -->
        <el-form-item label="Date">
          <div class="row-multi-item">
            <el-date-picker
              v-model="filter.recordDateRange"
              format="yyyy-MM"
              :clearable="false"
              value-format="yyyy-MM"
              type="monthrange"
              align="right"
              style="width: 260px"
              unlink-panels
              range-separator="to"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="monthPickerOptions"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="TimeZone">
          <div class="row-multi-item">
            <el-select v-model="filter.timezone">
              <el-option
                v-for="item in timezoneOption"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="Network Partner ID">
          <div class="row-multi-item">
            <el-input v-model="filter.networkPartnerId" />
            <el-checkbox
              v-model="groupItemCheck.networkPartnerIdChecked"
              name="network_partner_id"
            />
          </div>
        </el-form-item>
        <el-form-item label="Agency Partner ID">
          <div class="row-multi-item">
            <el-input v-model="filter.agencyPartnerId" />
            <el-checkbox v-model="groupItemCheck.agencyPartnerIdChecked" name="agency_partner_id" />
          </div>
        </el-form-item>
        <el-form-item label="Partner Adv Account">
          <div class="row-multi-item">
            <el-input v-model.trim="filter.partnerAdvertiserAccount" />
            <el-checkbox
              v-model="groupItemCheck.partnerAdvertiserAccountChecked"
              name="partner_advertiser_account"
            />
          </div>
        </el-form-item>
        <el-form-item label="OfferId">
          <div class="row-multi-item">
            <el-input v-model="offerIdList" />
            <el-checkbox v-model="groupItemCheck.offerIdChecked" name="offer_id" />
          </div>
        </el-form-item>
        <el-form-item label="OfferName">
          <div class="row-multi-item">
            <el-input v-model.trim="offerNameList" placeholder="多项请以;分隔" />
            <el-checkbox v-model="groupItemCheck.offerNameChecked" name="offer_name" />
          </div>
        </el-form-item>
        <el-form-item label="PKG Name">
          <div class="row-multi-item">
            <el-input v-model.trim="pkgNameList" placeholder="多项请以;分隔" />
            <el-checkbox v-model="groupItemCheck.pkgNameChecked" name="pkg_name" />
          </div>
        </el-form-item>
        <el-form-item label="Advertiser Offer ID">
          <div class="row-multi-item">
            <el-input v-model="advertiserOfferIdList" />
            <el-checkbox
              v-model="groupItemCheck.advertiserOfferIdChecked"
              name="advertiser_offer_id"
            />
          </div>
        </el-form-item>
        <el-form-item label="Advertiser Offer Name">
          <div class="row-multi-item">
            <el-input v-model="advertiserOfferNameList" />
            <el-checkbox
              v-model="groupItemCheck.advertiserOfferNameChecked"
              name="advertiser_offer_name"
            />
          </div>
        </el-form-item>

        <!-- 渠道筛选 -->
        <el-form-item label="AffiliateId">
          <div class="row-multi-item">
            <group-select
              v-model="filter.affiliateIdList"
              :data-source="affiliatesGroupList"
              multiple
              :loading="affiliateLoading"
              clearable
              filterable
              reserve-keyword
            />
            <el-checkbox v-model="groupItemCheck.affiliateChecked" name="affiliate_id" />
          </div>
        </el-form-item>
        <el-form-item label="AffiliateName">
          <div class="row-multi-item">
            <group-select
              v-model="affiliateNameList"
              :data-source="affiliatesGroupList"
              multiple
              :loading="affiliateLoading"
              clearable
              filterable
              reserve-keyword
            />
            <el-checkbox v-model="groupItemCheck.affiliateNameChecked" name="affiliate_name" />
          </div>
        </el-form-item>
        <el-form-item label="Affiliate AM">
          <div class="row-multi-item">
            <el-select v-model="filter.amList" filterable multiple clearable>
              <el-option
                v-for="item in allAmList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.amChecked" name="affiliate_am" />
          </div>
        </el-form-item>
        <el-form-item label="Affiliate BD">
          <div class="row-multi-item">
            <el-select v-model="filter.affBdList" filterable multiple clearable>
              <el-option
                v-for="item in allBdList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.bdChecked" name="aff_bd" />
          </div>
        </el-form-item>
        <el-form-item label="Aff Integration Type">
          <div class="row-multi-item">
            <el-select clearable v-model="filter.affiliateIntegrationType">
              <el-option v-for="item in integrationType" :key="item" :value="item" :label="item" />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.affIntegrationTypeChecked"
              name="affiliate_integration_type"
            />
          </div>
        </el-form-item>
        <el-form-item label="Aff Payment Status">
          <div class="row-multi-item">
            <el-select clearable v-model="filter.affPaymentStatus">
              <el-option
                v-for="item in affFullPaymentStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.affPaymentStatusChecked"
              name="aff_payment_status"
            />
          </div>
        </el-form-item>
        <el-form-item label="Aff Company Platform">
          <div class="row-multi-item">
            <el-select clearable filterable v-model="filter.affCompanyPlatform">
              <el-option
                v-for="item in companyPlatformList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.affCompanyPlatformChecked"
              name="fbd.aff_company_platform"
            />
          </div>
        </el-form-item>

        <!-- 广告主筛选 -->
        <el-form-item label="AdvertiserId">
          <div class="row-multi-item">
            <group-select
              v-model="filter.advertiserIdList"
              :data-source="sourcesList"
              multiple
              :loading="sourceLoading"
              clearable
              reserve-keyword
              filterable
            />
            <el-checkbox v-model="groupItemCheck.advertiserIdChecked" name="advertiser_id" />
          </div>
        </el-form-item>
        <el-form-item label="AdvertiserName">
          <div class="row-multi-item">
            <group-select
              v-model="filter.advertiserNameList"
              :data-source="sourcesNameList"
              multiple
              :loading="sourceLoading"
              clearable
              reserve-keyword
              filterable
            />
            <el-checkbox v-model="groupItemCheck.advertiserNameChecked" name="advertiser_name" />
          </div>
        </el-form-item>
        <el-form-item label="Adv Integration Type">
          <div class="row-multi-item">
            <el-select clearable v-model="filter.advertiserIntegrationType">
              <el-option v-for="item in integrationType" :key="item" :value="item" :label="item" />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.advIntegrationTypeChecked"
              name="advertiser_integration_type"
            />
          </div>
        </el-form-item>
        <el-form-item label="Adv Payment Status">
          <div class="row-multi-item">
            <el-select clearable v-model="filter.advReceiptStatus">
              <el-option
                v-for="item in advFullReceiptStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.advReceiptStatusChecked"
              name="adv_receipt_status"
            />
          </div>
        </el-form-item>
        <el-form-item label="Advertiser PM">
          <div class="row-multi-item">
            <el-select v-model="filter.pmList" filterable multiple clearable>
              <el-option
                v-for="item in allPmList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.pmChecked" name="advertiser_pm" />
          </div>
        </el-form-item>
        <el-form-item label="Advertiser BD">
          <div class="row-multi-item">
            <el-select v-model="filter.advBdList" filterable multiple clearable>
              <el-option
                v-for="item in allBdList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.bdChecked" name="advertiser_bd" />
          </div>
        </el-form-item>
        <el-form-item label="Adv Company Platform">
          <div class="row-multi-item">
            <el-select clearable filterable v-model="filter.advCompanyPlatform">
              <el-option
                v-for="item in companyPlatformList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.advCompanyPlatformChecked"
              name="fbd.adv_company_platform"
            />
          </div>
        </el-form-item>

        <!-- 额外申请单筛选 -->
        <el-form-item label="Adv Invoice Application Status">
          <div class="row-multi-item">
            <el-select clearable v-model="filter.advInvoiceAppStatus">
              <el-option
                v-for="item in affBillingAppStatusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.advInvoiceAppStatusChecked"
              name="adv_invoice_app_status"
            />
          </div>
        </el-form-item>
        <el-form-item label="Aff Billing Application Status">
          <div class="row-multi-item">
            <el-select clearable v-model="filter.affBillingAppStatus">
              <el-option
                v-for="item in affBillingAppStatusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.affBillingAppStatusChecked"
              name="aff_billing_app_status"
            />
          </div>
        </el-form-item>
        <el-form-item label="Adv Confirmed Status">
          <div class="row-multi-item">
            <el-select clearable v-model="filter.advReconciliationProgress">
              <el-option
                v-for="item in reconciliationProgressList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.advReconciliationProgressChecked"
              name="adv_reconciliation_progress"
            />
          </div>
        </el-form-item>
        <el-form-item label="Aff Confirmed Status">
          <div class="row-multi-item">
            <el-select clearable v-model="filter.affReconciliationProgress">
              <el-option
                v-for="item in reconciliationProgressList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.affReconciliationProgressChecked"
              name="aff_reconciliation_progress"
            />
          </div>
        </el-form-item>
        <el-form-item label="Country">
          <el-checkbox v-model="groupItemCheck.countryChecked" name="country" />
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" @click="handleSearch(1)">Search</el-button>
      <el-button type="primary" @click="openAddDialogClick()">
        Add
      </el-button>
      <el-button type="primary" @click="openUploadDialogClick">
        Upload
      </el-button>
      <el-button type="primary" :loading="exportDataLoading" @click="exportExcelFileClick">
        Download Excel
      </el-button>
      <el-button type="primary" :loading="downloadTemplateLoading" @click="downloadTemplateClick">
        Download Template
      </el-button>
      <el-button type="primary" @click="handleSelectAll">SelectAll</el-button>
      <el-button type="primary" @click="handleUnSelectAll">UnSelectAll</el-button>
      <el-button type="primary" @click="handleSelectArgument">开启更新删除</el-button>
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        :data="dataList"
        size="small"
        highlight-current-row
        show-summary
        @sort-change="handleSort"
        :summary-method="customSummaryMethod"
      >
        <el-table-column
          label="Date"
          prop="recordDate"
          fixed="left"
          align="center"
          width="120"
          key="recordDate"
        />
        <el-table-column
          label="Time Zone"
          prop="timezone"
          align="center"
          min-width="100"
          key="timezone"
        />
        <el-table-column
          label="Agency Partner ID"
          prop="agencyPartnerId"
          align="center"
          min-width="150"
          key="agencyPartnerId"
          v-if="groupItemCheck.agencyPartnerIdChecked"
        />
        <el-table-column
          label="Aff Integration Type"
          prop="affiliateIntegrationType"
          align="center"
          min-width="160"
          key="affiliateIntegrationType"
          v-if="groupItemCheck.affIntegrationTypeChecked"
        />
        <el-table-column
          label="Network Partner ID"
          prop="networkPartnerId"
          align="center"
          min-width="180"
          key="networkPartnerId"
          v-if="groupItemCheck.networkPartnerIdChecked"
        />
        <el-table-column
          label="Affiliate ID"
          min-width="100"
          align="center"
          v-if="groupItemCheck.affiliateChecked"
          key="affiliateId"
          prop="affiliateId"
        />
        <el-table-column
          label="Affiliate Name"
          width="140"
          align="center"
          v-if="groupItemCheck.affiliateNameChecked"
          key="affiliateName"
          prop="affiliateName"
        />
        <el-table-column
          label="Aff Company Platform"
          min-width="220"
          align="center"
          v-if="groupItemCheck.affCompanyPlatformChecked"
          key="affCompanyPlatform"
          prop="affCompanyPlatform"
        />
        <el-table-column
          label="Affiliate AM"
          min-width="100"
          align="center"
          v-if="groupItemCheck.amChecked"
          key="affiliateAm"
          prop="affiliateAm"
        />
        <el-table-column
          label="Affiliate BD"
          min-width="100"
          align="center"
          v-if="groupItemCheck.bdChecked"
          key="affBd"
          prop="affBd"
        />
        <el-table-column
          label="Adv Integration Type"
          min-width="180"
          align="center"
          v-if="groupItemCheck.advIntegrationTypeChecked"
          key="advertiserIntegrationType"
          prop="advertiserIntegrationType"
        />
        <el-table-column
          label="Partner Advertiser Account"
          prop="partnerAdvertiserAccount"
          align="center"
          min-width="240"
          key="partnerAdvertiserAccount"
        />
        <el-table-column
          label="Advertiser ID"
          min-width="120"
          align="center"
          v-if="groupItemCheck.advertiserIdChecked"
          key="advertiserId"
          prop="advertiserId"
        />
        <el-table-column
          label="Advertiser Name"
          min-width="150"
          align="center"
          v-if="groupItemCheck.advertiserNameChecked"
          key="advertiserName"
          prop="advertiserName"
        />
        <el-table-column
          label="Adv Company Platform"
          min-width="220"
          align="center"
          v-if="groupItemCheck.advCompanyPlatformChecked"
          key="advCompanyPlatform"
          prop="advCompanyPlatform"
        />
        <el-table-column
          label="Advertiser PM"
          prop="advertiserPm"
          align="center"
          width="140"
          key="advertiserPm"
          v-if="groupItemCheck.pmChecked"
        />
        <el-table-column
          label="Advertiser BD"
          prop="advertiserBd"
          align="center"
          width="140"
          key="advertiserBd"
          v-if="groupItemCheck.bdChecked"
        />
        <el-table-column
          label="Advertiser Offer ID"
          prop="advertiserOfferId"
          align="center"
          min-width="180"
          key="advertiserOfferId"
          v-if="groupItemCheck.advertiserOfferIdChecked"
        />
        <el-table-column
          label="Advertiser Offer Name"
          prop="advertiserOfferName"
          align="center"
          min-width="180"
          show-overflow-tooltip
          key="advertiserOfferName"
          v-if="groupItemCheck.advertiserOfferNameChecked"
        />
        <el-table-column
          label="Offer ID"
          align="center"
          v-if="groupItemCheck.offerIdChecked"
          width="110"
          key="offerId"
          prop="offerId"
        >
          <template slot-scope="scope">
            <span class="cor337ab7" @click="offerDetailClick(scope.row)">{{
              scope.row.offerId
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Offer Name"
          v-if="groupItemCheck.offerNameChecked"
          width="140"
          align="center"
          show-overflow-tooltip
          key="offerName"
          prop="offerName"
        >
          <template slot-scope="scope">
            <span class="cor337ab7" @click="offerDetailClick(scope.row)">{{
              scope.row.offerName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="PKG Name"
          align="center"
          v-if="groupItemCheck.pkgNameChecked"
          width="240"
          key="pkgName"
          prop="pkgName"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="Country"
          align="center"
          min-width="100"
          key="country"
          prop="country"
          v-if="groupItemCheck.countryChecked"
        />
        <el-table-column
          label="Conversion"
          align="center"
          min-width="140"
          sortable="custom"
          key="conversion"
          prop="conversion"
        />
        <el-table-column
          label="Revenue"
          align="center"
          min-width="140"
          sortable="custom"
          key="revenue"
          prop="revenue"
        />
        <el-table-column
          label="Adv Conversion"
          align="center"
          min-width="170"
          sortable="custom"
          key="advertiserConversion"
          prop="advertiserConversion"
        />
        <el-table-column
          label="Adv Revenue"
          align="center"
          min-width="140"
          sortable="custom"
          key="advertiserRevenue"
          prop="advertiserRevenue"
        />
        <el-table-column
          label="Adv Deduction Conversion"
          align="center"
          min-width="240"
          sortable="custom"
          key="advertiserDeductionConversion"
          prop="advertiserDeductionConversion"
        />
        <el-table-column
          label="Adv Deduction Amount"
          align="center"
          min-width="220"
          sortable="custom"
          key="advertiserDeductionAmount"
          prop="advertiserDeductionAmount"
        />
        <el-table-column
          label="Adv Cover Amount"
          align="center"
          min-width="180"
          sortable="custom"
          key="advertiserCoverAmount"
          prop="advertiserCoverAmount"
        />
        <el-table-column
          label="Adv Confirmed Conversion"
          align="center"
          min-width="230"
          sortable="custom"
          key="advertiserConfirmedConversion"
          prop="advertiserConfirmedConversion"
        />
        <el-table-column
          label="Adv Confirmed Amount"
          align="center"
          min-width="220"
          sortable="custom"
          key="advertiserConfirmedAmount"
          prop="advertiserConfirmedAmount"
        />
        <el-table-column
          label="Adv Payment Rate"
          align="center"
          min-width="170"
          sortable="custom"
          key="advPaymentRate"
          prop="advPaymentRate"
        >
          <template #default="scope">
            {{ numToPercentStr(scope.row.advPaymentRate) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Adv Hedge Amount"
          align="center"
          min-width="200"
          sortable="custom"
          key="advertiserHedgeAmount,"
          prop="advertiserHedgeAmount"
        />
        <el-table-column
          label="Adv Received Amount"
          align="center"
          min-width="220"
          sortable="custom"
          key="financeReceivedAmount"
          prop="financeReceivedAmount"
        />
        <el-table-column
          label="Adv Actual Amount"
          align="center"
          min-width="190"
          sortable="custom"
          key="advertiserActualAmount"
          prop="advertiserActualAmount"
        />
        <el-table-column
          label="Aff Conversion"
          align="center"
          min-width="170"
          sortable="custom"
          key="affiliateConversion"
          prop="affiliateConversion"
        />
        <el-table-column
          label="Aff Revenue"
          align="center"
          min-width="140"
          sortable="custom"
          key="affiliateRevenue"
          prop="affiliateRevenue"
        />
        <el-table-column
          label="Aff Deduction Conversion"
          align="center"
          min-width="240"
          sortable="custom"
          key="affiliateDeductionConversion"
          prop="affiliateDeductionConversion"
        />
        <el-table-column
          label="Aff Deduction Amount"
          align="center"
          min-width="200"
          sortable="custom"
          key="affiliateDeductionAmount"
          prop="affiliateDeductionAmount"
        />
        <el-table-column
          label="Aff Cover Amount"
          align="center"
          min-width="180"
          sortable="custom"
          key="affiliateCoverAmount"
          prop="affiliateCoverAmount"
        />
        <el-table-column
          label="Aff Confirmed Conversion"
          align="center"
          min-width="230"
          sortable="custom"
          key="affiliateConfirmedConversion"
          prop="affiliateConfirmedConversion"
        />
        <el-table-column
          label="Aff Confirmed Amount"
          align="center"
          min-width="180"
          key="affiliateConfirmedAmount"
          prop="affiliateConfirmedAmount"
        />
        <el-table-column
          label="Aff Payment Rate"
          align="center"
          min-width="180"
          sortable="custom"
          key="affPaymentRate"
          prop="affPaymentRate"
        >
          <template #default="scope">
            {{ numToPercentStr(scope.row.affPaymentRate) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Aff Hedge Amount"
          align="center"
          min-width="180"
          sortable="custom"
          key="affiliateHedgeAmount"
          prop="affiliateHedgeAmount"
        />
        <el-table-column
          label="Aff Payment Amount"
          align="center"
          min-width="220"
          sortable="custom"
          key="financePaymentAmount"
          prop="financePaymentAmount"
        />
        <el-table-column
          label="Aff Actual Amount"
          align="center"
          min-width="180"
          sortable="custom"
          key="affiliateActualAmount"
          prop="affiliateActualAmount"
        />
        <el-table-column
          label="Estimated Profit"
          align="center"
          min-width="150"
          key="estimatedProfit"
          prop="estimatedProfit"
        />
        <el-table-column
          label="Estimated Profit Rate"
          align="center"
          min-width="180"
          key="estimatedProfitRate"
          prop="estimatedProfitRate"
        >
          <template #default="scope">
            {{ numToPercentStr(scope.row.estimatedProfitRate) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Profit"
          align="center"
          min-width="150"
          key="actualProfit"
          prop="actualProfit"
        />
        <el-table-column
          label="Actual Profit Rate"
          align="center"
          min-width="150"
          key="actualProfitRate"
          prop="actualProfitRate"
        >
          <template #default="scope">
            {{ numToPercentStr(scope.row.actualProfitRate) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Adv Confirm Status"
          align="center"
          min-width="240"
          key="advReconciliationProgress"
          prop="advReconciliationProgress"
          v-if="groupItemCheck.advReconciliationProgressChecked"
        >
          <template #default="scope">
            {{ getEnumLabel(reconciliationProgressList, scope.row.advReconciliationProgress) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Aff Confirm Status"
          align="center"
          min-width="240"
          key="affReconciliationProgress"
          prop="affReconciliationProgress"
          v-if="groupItemCheck.affReconciliationProgressChecked"
        >
          <template #default="scope">
            {{ getEnumLabel(reconciliationProgressList, scope.row.affReconciliationProgress) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Adv Invoice Application Status"
          align="center"
          min-width="250"
          v-if="groupItemCheck.advInvoiceAppStatusChecked"
          key="advInvoiceAppStatus"
          prop="advInvoiceAppStatus"
        >
          <template #default="scope">
            {{ getBillingAppStatusLabel(scope.row.advInvoiceAppStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Aff Billing Application Status"
          align="center"
          min-width="250"
          v-if="groupItemCheck.affBillingAppStatusChecked"
          key="affBillingAppStatus"
          prop="affBillingAppStatus"
        >
          <template #default="scope">
            {{ getBillingAppStatusLabel(scope.row.affBillingAppStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Adv Payment Status"
          align="center"
          min-width="170"
          key="advReceiptStatus"
          prop="advReceiptStatus"
          v-if="groupItemCheck.advReceiptStatusChecked"
        >
          <template #default="scope">
            {{ getEnumLabel(advFullReceiptStatusList, scope.row.advReceiptStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Aff Payment Status"
          align="center"
          min-width="170"
          key="affPaymentStatus"
          prop="affPaymentStatus"
          v-if="groupItemCheck.affPaymentStatusChecked"
        >
          <template #default="scope">
            {{ getEnumLabel(affFullPaymentStatusList, scope.row.affPaymentStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="Note" align="center" min-width="100" key="note" prop="note" />
        <el-table-column
          label="Data Source"
          align="center"
          min-width="170"
          key="dataSource"
          prop="dataSource"
        />
        <el-table-column
          label="last Updated Data Source"
          align="center"
          min-width="250"
          key="lastUpdatedDataSource"
          prop="lastUpdatedDataSource"
        />
        <el-table-column
          label="Create By"
          align="center"
          min-width="150"
          key="createBy"
          prop="createBy"
        />
        <el-table-column
          label="Create Time"
          align="center"
          min-width="180"
          key="createTime"
          prop="createTime"
        />
        <el-table-column
          label="Updated By"
          align="center"
          min-width="150"
          key="updatedBy"
          prop="updatedBy"
        />
        <el-table-column
          label="Updated Time"
          align="center"
          min-width="180"
          key="updatedTime"
          prop="updatedTime"
        />
        <el-table-column label="Operation" align="center" min-width="210" fixed="right">
          <template #default="scope">
            <div class="table-actions-container">
              <el-button type="primary" @click="handleUpdate(scope.row)">Update</el-button>
              <el-button type="danger" @click="handleDelete(scope.row.id)">
                Delete
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      ></pagination>
    </template>
    <template #dialog>
      <el-dialog
        title="Upload"
        :visible.sync="uploadVisible"
        append-to-body
        width="35%"
        :close-on-click-modal="false"
        destroy-on-close
      >
        <div style="text-align: center">
          <el-upload
            class="upload-demo"
            drag
            :action="api.DETAIL_BILLING_UPLOAD"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="true"
            accept=".xlsx, .xls"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">
              <p>只能上传xlsx或者xls格式文件，且不超过5M</p>
              <el-button
                style="margin-top: 10px"
                type="primary"
                :loading="downloadTemplateLoading"
                @click="downloadTemplateClick"
              >
                Download Template
              </el-button>
            </div>
          </el-upload>
          <transition name="el-zoom-in-top">
            <div>{{ uploadSuccessMessage }}</div>
          </transition>
          <transition name="el-zoom-in-top">
            <div v-show="isNotBlank(uploadErrorMessage)">
              <el-alert
                style="margin: 5px 0"
                v-for="(item, index) in splitStrByLineBreak(uploadErrorMessage)"
                :key="index"
                :title="item"
                type="error"
              />
            </div>
          </transition>
        </div>
      </el-dialog>
      <billing-detail-base-form
        :add-detail="addDetail"
        :base-form-visible.sync="baseFormVisible"
        :base-form-type="baseFormType"
        @refresh-list="handleSearch"
      />
    </template>
  </base-list-layout>
</template>
<style scoped lang="scss"></style>
